import { PokerGameFormatType, PokerGameModel, PokerGameSNGStatusType } from 'mvppoker-portal-common/api'
import MathUtils from 'mvppoker-portal-common/utils/MathUtils'
import React from 'react'
import './RoomsTable.scss'

export interface RoomTableProps {
	format: PokerGameFormatType
	rooms: PokerGameModel[]
	selectedRoom?: string
	onSelectRoom: (id: string) => void
}

export const RoomTable = ({ format, rooms, selectedRoom, onSelectRoom }: RoomTableProps) => {
	if (format === PokerGameFormatType.Sng){

		const entries = rooms.map((room) => {
			const isPlaying = room.sngData?.status === PokerGameSNGStatusType.Playing
			const activePlayers = room.players.length
			const { maxPlayers } = room.config
			// const { minimumPlayers } = room.config.sngConfig!
	
			const cs = room.id === selectedRoom ? 'selected' : ''
	
			const prizes = room.config.sngConfig!.prizeMultipliers.map(p => `${MathUtils.MultiplyNumbers(p, '100')}%`).join(' • ')

			return (
				<tr key={room.id} className={cs} onClick={() => onSelectRoom(room.id)}>
					<td>{room.config.roomName}</td>
					<td>{room.config.type}</td>
					<td>{isPlaying ? `${activePlayers} PLAYING` : `OPEN ${activePlayers}/${maxPlayers}`}</td>
					{/* <td>{minimumPlayers}</td> */}
					<td>{room.dealer?.info?.name || '-'}</td>
					<td>{prizes}</td>
					<td>${room.config.minimumBuyIn}</td>
				</tr>
			)
		})
		return (
			<table id='room-table'>
				<thead>
					<tr>
						<th>Room name</th>
						<th>Type</th>
						<th>status</th>
						<th>dealer</th>
						<th>prizes</th>
						<th>buy in</th>
					</tr>
				</thead>
				<tbody>{entries}</tbody>
			</table>
		)
	}

	const entries = rooms.map((room) => {
		const totalPot = room?.statistics?.totalPotAmount ?? '0'
		const gamesInPot = `${room?.statistics?.gamesPlayed ?? 0}`
		const avgPot = MathUtils.IsBiggerThanZero(gamesInPot) ? MathUtils.Format(MathUtils.DivideNumbers(totalPot, gamesInPot)) : '0.0'
		const activePlayers = room.players.length
		const { maxPlayers } = room.config

		const cs = room.id === selectedRoom ? 'selected' : ''

		return (
			<tr key={room.id} className={cs} onClick={() => onSelectRoom(room.id)}>
				<td>{room.config.roomName}</td>
				<td>{room.config.type}</td>
				<td>
					{room.config.smallBlindAmount}/{room.config.bigBlindAmount}
				</td>
				<td>{room.dealer?.info?.name || '-'}</td>
				<td>${avgPot}</td>
				<td>
					{activePlayers}/{maxPlayers}
				</td>
			</tr>
		)
	})
	return (
		<table id='room-table'>
			<thead>
				<tr>
					<th>Room name</th>
					<th>Type</th>
					<th>stakes</th>
					<th>dealer</th>
					<th>avg. pot</th>
					<th>players</th>
				</tr>
			</thead>
			<tbody>{entries}</tbody>
		</table>
	)
}
